export const VIBRANT_PALETTE = [
    '#667eea',
    '#764ba2',
    '#f093fb',
    '#f5576c',
    '#4facfe',
    '#00b4d8',
    '#43e97b',
    '#38b000',
    '#fa709a',
    '#f6c23e',
    '#ff6b6b',
    '#feca57',
    '#48dbfb',
    '#e83e8c',
    '#54a0ff',
    '#5f27cd',
];

/** Matches admin Patient Stats chart colors (NiceAdmin). */
export const PATIENT_STATS_PALETTE = [
    '#4154f1',
    '#0aa2c0',
    '#198754',
    '#e8590c',
    '#6c757d',
    '#6f42c1',
];

/** Matches admin Communication Preferences: light fill, solid border. */
export const CHART_FILL_ALPHA = 0.82;
export const CHART_BORDER_WIDTH = 2;

export const hexToRgba = (hex, alpha = 1) => {
    const value = String(hex || '').replace('#', '').trim();
    const full = value.length === 3 ? value.split('').map((char) => char + char).join('') : value;
    if (full.length !== 6) {
        return `rgba(65, 84, 241, ${alpha})`;
    }

    const n = parseInt(full, 16);
    return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
};

export const getSeriesColors = (series = []) =>
    series.map((item, index) => item.color || VIBRANT_PALETTE[index % VIBRANT_PALETTE.length]);

export const getSeriesFills = (series = [], alpha = CHART_FILL_ALPHA) =>
    getSeriesColors(series).map((color) => hexToRgba(color, alpha));

export const getAccentColor = (index = 0, fallback) =>
    fallback || VIBRANT_PALETTE[index % VIBRANT_PALETTE.length];
